import React, { useEffect, useRef, useState } from "react";
import { components } from "react-select";
import classNames from "classnames";

import { ReactComponent as CloseIcon } from "src/images/mutableCloseIcon.svg";
import { ReactComponent as CircleCrossIcon } from "src/images/circle-cross.svg";

export default function CustomSelectComponents(props) {
  return {
    ClearIndicator: (clearProps) => (
      <div
        className="ws-react-select__clear-indicator"
        {...clearProps.innerProps}
      >
        <CircleCrossIcon />
      </div>
    ),
    Menu: (menuProps) => <components.Menu {...menuProps} className="menu" />,
    MenuList: (menuListProps) => (
      <div
        className="ws-react-select__menu-list-wrap"
        style={{ maxHeight: menuListProps.maxHeight }}
      >
        <div className="ws-react-select__menu-list">
          {menuListProps.children}
        </div>
        {props.afterMenuList}
      </div>
    ),
    MultiValueRemove: (removeProps) => {
      return (
        <div {...removeProps.innerProps}>
          <CloseIcon
            {...removeProps}
            width={16}
            height={16}
            fill={removeProps.data.color || "#8E93AC"}
          />
        </div>
      );
    },
    Option: ({ children, data, ...optionProps }) => {
      const ref = useRef(null);

      const [textValue, setTextValue] = useState("custom-option");

      const getTextValue = () => {
        if (!ref?.current) return "custom-option";
        const { textContent, outerText, innerText } = ref.current;
        if (textContent) return textContent;
        if (outerText) return outerText;
        if (innerText) return innerText;
        return "custom-option";
      };

      useEffect(() => {
        setTextValue(getTextValue());
      }, []);

      return (
        <components.Option
          className={classNames(
            "className" in data && data.className,
            optionProps.innerProps?.className,
          )}
          {...optionProps}
        >
          <div ref={ref} className="idh-select-option" data-qa={textValue}>
            {children}
            {"customElement" in data && data.customElement}
          </div>
        </components.Option>
      );
    },
    ...props.components,
  };
}
